import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const ConfluenceIntegration = React.lazy(() => import("./ConfluenceIntegration"));

interface ConfluenceIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ConfluenceIntegrationLazy(props: ConfluenceIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <ConfluenceIntegration {...props} />
    </Suspense>
  );
}
